import React, { useEffect, useState } from "react";
import { Typography } from "@mui/material";
import { DetailInfoComponentModel } from "../../models/components.model";
import Grid from "@mui/material/Grid";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import DocumentInfoComponent from "./documentInfoComponent";
import NoImageFoundDocument from "../thumbnail/noImageFoundDocument";

export default function DetailInfoVehicle({
    documentList,
    title,
    height,
    addressByInquiry,
    showFooter,
    showDoc,
    isGuarantor
}: DetailInfoComponentModel) {
    return (
        <>
            <Grid
                container
                xs={12}
                spacing={2}
                columns={{ xs: 2, sm: 8, md: 12 }}
                style={{ paddingRight: "5vh" }}
            >
                {(showDoc == undefined || showDoc == true)
                    ? documentList?.map((item: any) => (
                        <Grid item xs={2} style={{
                            marginTop: '2vh'
                        }}>
                            {item.fileUrl ? (
                                <DocumentInfoComponent
                                    data={item}
                                    title={isGuarantor ? item.documentTypeTitle : title}
                                    showFooter={showFooter}
                                    height={height}
                                    isGuarantor={isGuarantor ? isGuarantor : false}
                                />
                            ) : (
                                <NoImageFoundDocument />
                            )}
                        </Grid>
                    ))
                    : null}
            </Grid>

        </>
    );
}
